var map = {
	"./T7193.png": "2896",
	"./T7396.png": "2c63",
	"./T7399.png": "f2f8",
	"./T7399_login_icon.png": "3658",
	"./T7399_test.png": "2637",
	"./T7404.png": "eb62",
	"./T7404Test.png": "591d",
	"./amgo.png": "ff23",
	"./amgo_sgp.png": "9bf4",
	"./amgo_third.png": "9922",
	"./amigo_vi.png": "0249",
	"./amigo_vi_login.png": "1f73",
	"./ftp.png": "0910",
	"./ftp_test.png": "64be",
	"./myntra.png": "3768",
	"./myntra_test.png": "aa51",
	"./shopee.png": "4f52",
	"./test.png": "5f12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb1a";